import React from 'react';

import useAISummary from './useAISummary';
import Alert from '@material-ui/lab/Alert';
import Spinner from '../common/Spinner';
import AISummaryTooltip from './AISummaryTooltip';
import { NOT_A_STRAIN } from '../products/DisplayStrainName';

import styles from './StrainDescription.module.css';

export const AI_STRAIN_SUMMARY_CATEGORIES = ['flower', 'pre-rolls'];
const AI_PRODUCT_SUMMARY_CATEGORIES = ['accessories', 'concentrates','edibles', 'tinctures', 'topicals', 'vaporizers'];

export const shouldDisplayAISummary = (category, strain_name) => {
  const { name:categoryName } = category || {};
  if (categoryName) {
    return AI_PRODUCT_SUMMARY_CATEGORIES.includes(categoryName) ||
      (AI_STRAIN_SUMMARY_CATEGORIES.includes(categoryName) &&
       strain_name && !NOT_A_STRAIN.includes(strain_name.toLowerCase()));
  }
  return false;
}

const AISummary = ({product}) => {

  const { dutchie_sku } = product;
  const { category, name, strain_name } = product.display_info;

  const promptText = AI_STRAIN_SUMMARY_CATEGORIES.includes(category.name)
    ? strain_name
    : name; // product name

  const { aiSummary, loading } = useAISummary(dutchie_sku, promptText);

  return (
    loading
      ? <div style={{padding:'2rem 0', minHeight:300}}>
          <Spinner inSmallLayout color={'#000'} size={48} />
        </div>
      : aiSummary
        ? <>
            <div className={styles.aiSummary} dangerouslySetInnerHTML={{ __html:`${aiSummary}`}} />
            <AISummaryTooltip inModal={true} />
          </>
        : <Alert severity='info'>
            Sorry, a this content is not currently available...
          </Alert>
  );
}

export default AISummary;
